app.factory("StSubject", ["$http",
    function ($http) {
        var Subject = {};

        Subject.list = function (req) {
            var student = req.student;
            return $http.get("/subject/student/list", {
                params: {student: student}
            }).then(function (resp) {
                return resp.data;
            });
        };

        Subject.listBySemester = function (req) {
            var student = req.student;
            return $http.get("/subject/student/current", {
                params: {student: student}
            }).then(function (resp) {
                return resp.data;
            });
        };

        Subject.gradeList = function (req) {
            return $http.get("/subject/grade/list", {
                params: {selection: req._id}
            }).then(function (resp) {
                return resp.data;
            });
        };

        Subject.totals = function (req) {
            var student = req.student;
            return $http.get("/subject/totals", {
                params: {student: student}
            }).then(function (resp) {
                return resp.data;
            });
        };

        return Subject;
    }
]);